import { Dropdown, DropdownItem } from '@/components/common/dropdown';
import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { SettingMenuContext } from '@/contexts/SettingMenuContext';
import { getLocaleByCode } from '@/models/Locale';
import { useContext } from 'react';
type HandleChangeLanguage = (language: string) => void;
type LanguageSelectorProps = {
    language: string;
    handleChangeLanguage: HandleChangeLanguage;
};
export const LanguageSelector = (props: LanguageSelectorProps) => {
    const { language, handleChangeLanguage } = props;
    const btnLanguageText = getLocaleByCode('long', language).fullName;
    // const [locales, setLocales] = useState<Array<LocaleCode>>([]);
    const { playButtonAudio } = useContext(AudioPlayContext);
    // const { onlyLangList, langOnly, langExclude } =
    //     useContext(CommonConfigContext);
    // const { LobbyCode: serLobbyCode } = useSelector((state: RootState) =>
    //     getMainUserState(state)
    // );
    const { locales } = useContext(SettingMenuContext);
    const onLanguageChange = (lang: string) => {
        handleChangeLanguage(lang);
        playButtonAudio();
    };
    return (
        <Dropdown
            className="language-selector"
            placeholder={btnLanguageText}
            disableTranslation
        >
            {locales.map((l, i) => {
                return (
                    <DropdownItem
                        onClick={() => onLanguageChange(l.long)}
                        key={`language-selector-${i}`}
                        text={l.fullName}
                        isChecked={language === l.long}
                    />
                );
            })}
        </Dropdown>
    );
};
